import GeaoLayout from "./GeaoLayout";

export default function CobrandLayout({ children, partnerName, header, subHeader }) {
    const normalizedPartnerName = partnerName?.toLowerCase().replace(/\s+/g, '-');
    return (
        <GeaoLayout
            header={header}
            subHeader={subHeader}
            logoHref="/"
            skipToContent
            partnerLogo={
                <img
                    className="partner-logo__image pl-2"
                    src={`/images/partner-logo/${normalizedPartnerName}.png`}
                    alt={`${partnerName} logo`}
                    width={150}
                    height={50}
                    onError={(e) => {
                        e.currentTarget.style.display = 'none';
                    }}
                />
            }
        >
            {children}
        </GeaoLayout>
    );
}
